(function () {
  'use strict';

  var addToCartButton = null;
  var returnFocusTarget = null;
  var savedScrollY = null;
  var bundleCompositeMap = null;
  var productImageMap = null;
  var preloadedDrawerImages = [];

  function getBundleCompositeMap() {
    if (bundleCompositeMap !== null) return bundleCompositeMap;

    var dataElement = document.querySelector('[data-cart-drawer-bundle-composites]');
    bundleCompositeMap = {};

    if (!dataElement) return bundleCompositeMap;

    try {
      bundleCompositeMap = JSON.parse(dataElement.textContent);
    } catch (error) {
      bundleCompositeMap = {};
    }

    return bundleCompositeMap;
  }

  function getProductImageMap() {
    if (productImageMap !== null) return productImageMap;

    var dataElement = document.querySelector('[data-cart-drawer-product-images]');
    productImageMap = {};

    if (!dataElement) return productImageMap;

    try {
      productImageMap = JSON.parse(dataElement.textContent);
    } catch (error) {
      productImageMap = {};
    }

    return productImageMap;
  }

  function preloadDrawerImage(url) {
    if (!url) return;

    var image = new Image();
    image.decoding = 'async';
    image.src = url;
    preloadedDrawerImages.push(image);
  }

  function preloadCurrentProductImages() {
    var dataElement = document.querySelector('[data-cart-drawer-product-images]');
    var productId = dataElement && dataElement.getAttribute('data-current-product-id');
    if (!productId) return;

    var compositeImages = getBundleCompositeMap()[String(productId)] || [];
    var productImage = getProductImageMap()[String(productId)];

    for (var index = 0; index < compositeImages.length; index += 1) {
      preloadDrawerImage(compositeImages[index]);
    }

    preloadDrawerImage(productImage);
  }

  function renderBundleComposite(itemElement, cartItem) {
    var imageStage = itemElement.querySelector('[data-cart-item-background-image]');
    if (!imageStage) return;
    imageStage.setAttribute('aria-label', 'View ' + cartItem.product_title);

    var existingComposite = imageStage.querySelector('[data-cart-item-composite]');
    var images = getBundleCompositeMap()[String(cartItem.product_id)] || [];

    if (!images.length) {
      imageStage.classList.remove('cart-drawer__item-image--composite');
      if (existingComposite) existingComposite.remove();

      var productImage = getProductImageMap()[String(cartItem.product_id)];
      if (productImage) imageStage.style.backgroundImage = 'url(' + productImage + ')';
      return;
    }

    imageStage.classList.add('cart-drawer__item-image--composite');
    imageStage.style.backgroundImage = 'none';

    var composite = existingComposite || document.createElement('span');
    composite.className = 'cart-drawer__item-composite';
    composite.setAttribute('data-cart-item-composite', '');
    composite.setAttribute('data-piece-count', images.length);
    composite.textContent = '';

    for (var index = 0; index < images.length; index += 1) {
      var artwork = document.createElement('img');
      artwork.className = 'cart-drawer__item-artwork';
      artwork.src = images[index];
      artwork.alt = '';
      artwork.loading = 'eager';
      composite.appendChild(artwork);
    }

    if (!existingComposite) imageStage.appendChild(composite);
  }

  function updateQuantityControl(itemElement, quantity) {
    var decreaseButton = itemElement.querySelector('[data-cart-item-quantity-decrease]');
    if (!decreaseButton) return;

    decreaseButton.disabled = false;
    decreaseButton.setAttribute(
      'aria-label',
      Number(quantity) <= 1 ? 'Remove item' : 'Decrease quantity'
    );
  }

  function resetCheckoutLoader() {
    var checkoutButtons = document.querySelectorAll(
      '.cart-drawer__checkout.btn--loader-active'
    );

    for (var index = 0; index < checkoutButtons.length; index += 1) {
      checkoutButtons[index].classList.remove('btn--loader-active');
    }
  }

  function formatCartMoney(cents) {
    var format = window.theme && theme.moneyFormat ? theme.moneyFormat : '${{amount}}';
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = placeholder ? placeholder[1] : 'amount';
    var precision = 0;
    var thousands = key.indexOf('comma_separator') !== -1 ? '.' : ',';
    var value = Math.round(Number(cents) / 100).toFixed(precision);
    var parts = value.split('.');

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    value = parts[0];

    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace('$ ', '$');
  }

  function moneyMarkupToNumber(markup) {
    var container = document.createElement('div');
    container.innerHTML = markup || '';

    var normalized = container.textContent.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    return Number(normalized) || 0;
  }

  function formatApproximateMonthly(cents) {
    var container = document.createElement('div');
    container.innerHTML = formatCartMoney(Math.round(Number(cents) / 100) * 100);

    return container.textContent.replace('$ ', '$').replace(/\.00$/, '');
  }

  function getShopPayMonthlyTerms(totalPrice) {
    var termsElement = document.querySelector(
      '[data-cart-payment-terms-source] shopify-payment-terms'
    );
    if (!termsElement) return 0;

    var metadata;

    try {
      metadata = JSON.parse(termsElement.getAttribute('shopify-meta') || '{}');
    } catch (error) {
      return 0;
    }

    if (metadata.country_code !== 'US' || !metadata.financing_plans) return 0;

    var total = Number(totalPrice) / 100;
    var matchingPlan = metadata.financing_plans.find(function (plan) {
      return total >= moneyMarkupToNumber(plan.min_price) &&
        total <= moneyMarkupToNumber(plan.max_price);
    });
    if (!matchingPlan || !matchingPlan.terms) return 0;

    return matchingPlan.terms.reduce(function (longestTerm, term) {
      if (term.loan_type !== 'interest') return longestTerm;
      return Math.max(longestTerm, Number(term.installments_count) || 0);
    }, 0);
  }

  function updateShopPayMonthly(totalPrice) {
    var monthlyElement = document.querySelector('[data-cart-shop-pay-monthly]');
    if (!monthlyElement) return;

    var numberOfTerms = getShopPayMonthlyTerms(totalPrice);
    if (!numberOfTerms) {
      monthlyElement.hidden = true;
      monthlyElement.textContent = '';
      return;
    }

    var monthlyPrice = formatApproximateMonthly(Number(totalPrice) / numberOfTerms);
    monthlyElement.textContent = 'or from ~' + monthlyPrice + '/mo with Shop Pay';
    monthlyElement.hidden = false;
  }

  function updateShippingUtility(state) {
    var utility = document.querySelector('[data-cart-shipping-utility]');
    if (!utility) return;

    var label = utility.querySelector('[data-cart-shipping-utility-label]');
    var detail = utility.querySelector('[data-cart-shipping-utility-detail]');
    if (!label || !detail) return;

    var thresholdUsd = Number(utility.getAttribute('data-free-shipping-threshold-usd'));
    var currencyRate = window.Shopify && Shopify.currency
      ? Number(Shopify.currency.rate)
      : 1;
    var threshold = Math.ceil(thresholdUsd * (currencyRate > 0 ? currencyRate : 1));
    var countryGetsFreeShipping = utility.getAttribute(
      'data-free-shipping-country-free'
    ) === 'true';

    if (countryGetsFreeShipping || state.total_price >= threshold) {
      label.textContent = 'Free shipping';
      detail.textContent = 'Ships ready to hang';
      return;
    }

    label.textContent = 'Add ' + formatCartMoney(threshold - state.total_price);
    detail.textContent = 'For free shipping';
  }

  // Mirrors the PDP production-run card (sections/gh-new-product-template.liquid): an order
  // joins the next run, and delivery is counted from today before 10 AM Eastern, otherwise
  // from the next business day.
  function addBusinessDays(date, numberOfDays) {
    var result = new Date(date.getTime());
    var remaining = numberOfDays;
    while (remaining > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) remaining -= 1;
    }
    return result;
  }

  function formatDeliveryRange(startDate, endDate) {
    var monthFormat = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' });
    var startMonth = monthFormat.format(startDate);
    var endMonth = monthFormat.format(endDate);
    if (startMonth === endMonth) {
      return startMonth + ' ' + startDate.getUTCDate() + '–' + endDate.getUTCDate();
    }
    return startMonth + ' ' + startDate.getUTCDate() + '–' + endMonth + ' ' + endDate.getUTCDate();
  }

  function updateBatchUtility() {
    var utility = document.querySelector('[data-cart-batch-utility]');
    if (!utility || !window.Intl || !Intl.DateTimeFormat) return;

    var label = utility.querySelector('[data-cart-batch-utility-label]');
    var detail = utility.querySelector('[data-cart-batch-utility-detail]');
    var minimumDays = Number(utility.getAttribute('data-delivery-min-business-days'));
    var maximumDays = Number(utility.getAttribute('data-delivery-max-business-days'));
    if (!label || !detail || !minimumDays || !maximumDays) return;

    try {
      var easternFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
      var partsFor = function (date) {
        var result = {};
        easternFormatter.formatToParts(date).forEach(function (part) {
          if (part.type !== 'literal') result[part.type] = part.value;
        });
        return result;
      };
      var parts = partsFor(new Date());
      // The label stays a simple "Order now"; delivery is counted from today before 10 AM
      // Eastern, otherwise from the next business day, matching the PDP production card.
      label.textContent = 'Order now';
      var DELIVERY_ANCHOR_HOUR_ET = 10;

      var orderDate = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12, 0, 0));
      var anchor = Number(parts.hour) < DELIVERY_ANCHOR_HOUR_ET ? orderDate : addBusinessDays(orderDate, 1);
      detail.textContent = 'Est. delivery ' + formatDeliveryRange(
        addBusinessDays(anchor, minimumDays),
        addBusinessDays(anchor, maximumDays)
      );
    } catch (error) {
      return;
    }
  }

  function updateCartPriceSection(state) {
    var subtotalElement = document.querySelector('[data-cart-subtotal]');
    if (subtotalElement) subtotalElement.innerHTML = formatCartMoney(state.total_price);

    updateShopPayMonthly(state.total_price);
    updateShippingUtility(state);
  }

  function updateLinePrice(itemElement, cartItem) {
    var priceContainer = itemElement.querySelector('[data-cart-item-price-container]');
    if (!priceContainer) return;

    var visiblePrice = priceContainer.querySelector('.cart-item__price');
    var originalPrice = priceContainer.querySelector('del.cart-item__original-price');

    if (visiblePrice) visiblePrice.innerHTML = formatCartMoney(cartItem.final_line_price);
    if (originalPrice) originalPrice.innerHTML = formatCartMoney(cartItem.original_line_price);
  }

  function updateItemSubtitle(itemElement, cartItem) {
    var subtitle = itemElement.querySelector('[data-cart-item-variant-title]');
    if (!subtitle) return;

    var pieceCount = (getBundleCompositeMap()[String(cartItem.product_id)] || []).length;
    var subtitleParts = [];

    if (pieceCount > 1) subtitleParts.push(pieceCount + '-piece set');
    if (cartItem.variant_title && cartItem.variant_title !== 'Default Title') {
      subtitleParts.push(cartItem.variant_title.replace(/\s*\/\s*/g, ' · '));
    }

    subtitle.textContent = subtitleParts.join(' · ');
    subtitle.parentElement.hidden = subtitleParts.length === 0;
  }

  function updateCartItemCount(itemCount) {
    var countElements = document.querySelectorAll('[data-cart-drawer-item-count]');
    var label = itemCount + (Number(itemCount) === 1 ? ' item in cart' : ' items in cart');

    for (var index = 0; index < countElements.length; index += 1) {
      countElements[index].textContent = label;
    }
  }

  function syncBundleComposites(state) {
    if (!state || !state.items) return;

    updateCartItemCount(state.item_count);
    updateCartPriceSection(state);
    updateBatchUtility();

    var itemElements = document.querySelectorAll(
      '.cart-drawer [data-cart-item]:not(.ajax-cart__template):not([data-cart-note-container])'
    );

    for (var index = 0; index < itemElements.length; index += 1) {
      if (!state.items[index]) continue;
      renderBundleComposite(itemElements[index], state.items[index]);
      updateItemSubtitle(itemElements[index], state.items[index]);
      updateQuantityControl(itemElements[index], state.items[index].quantity);
      updateLinePrice(itemElements[index], state.items[index]);
      var removeButton = itemElements[index].querySelector('[data-cart-item-delete]');
      if (removeButton) {
        removeButton.setAttribute('aria-label', (removeButton.getAttribute('data-remove-label') || 'Remove') + ' ' + state.items[index].product_title);
      }
    }
  }

  function changeItemQuantity(event) {
    var decreaseButton = event.target.closest('[data-cart-item-quantity-decrease]');
    var increaseButton = event.target.closest('[data-cart-item-quantity-increase]');
    var button = decreaseButton || increaseButton;
    if (!button) return;

    var itemElement = button.closest('[data-cart-item]');
    var input = itemElement && itemElement.querySelector('[data-cart-item-input-quantity]');
    if (!input) return;

    event.preventDefault();

    var currentQuantity = Number(input.value) || 1;
    var nextQuantity = Math.max(0, currentQuantity + (increaseButton ? 1 : -1));
    if (nextQuantity === currentQuantity) return;

    input.value = nextQuantity;

    if (nextQuantity === 0) {
      var removeButton = itemElement.querySelector('[data-cart-item-delete]');
      if (removeButton) removeButton.click();
      return;
    }

    updateQuantityControl(itemElement, nextQuantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function visibleCartToggle() {
    var toggles = document.querySelectorAll('.ajax-cart__toggle');
    var fallback = toggles.length ? toggles[0] : null;

    for (var index = 0; index < toggles.length; index += 1) {
      if (toggles[index].offsetParent !== null) return toggles[index];
    }

    return fallback;
  }

  function restoreCheckoutState() {
    if (!addToCartButton || !document.documentElement.contains(addToCartButton)) return;

    var primaryText = addToCartButton.querySelector('[data-cart-primary-submit-text]');
    var secondaryText = addToCartButton.querySelector('[data-cart-secondary-submit-text]');
    var checkoutText = window.theme && theme.strings ? theme.strings.checkout : 'Checkout';

    addToCartButton.classList.remove('product__add-to-cart-button-pending');
    addToCartButton.classList.add(
      'btn--to-secondary-transitioned',
      'ajax-checkout__toggle',
      'product__add-to-cart-button-clicked'
    );
    addToCartButton.setAttribute('aria-label', checkoutText);

    if (primaryText) primaryText.setAttribute('aria-hidden', 'true');
    if (secondaryText) {
      secondaryText.textContent = checkoutText;
      secondaryText.setAttribute('aria-hidden', 'false');
    }
  }

  function restoreScrollPosition() {
    if (savedScrollY === null) return;
    window.scrollTo(0, savedScrollY);
  }

  if (window.jQuery) {
    window.jQuery(document).on(
      'cart_update_done.perceptCartComposites',
      function (event, instance, state) {
        syncBundleComposites(state);
      }
    );

    window.jQuery(document).on('drawer_close_start.perceptAtcDrawer', function () {
      if (savedScrollY === null) return;

      window.Promise.resolve().then(restoreScrollPosition);
    });

    window.jQuery(document).on('drawer_close_done.perceptAtcDrawer', function () {
      if (savedScrollY === null) return;

      restoreScrollPosition();

      if (returnFocusTarget && document.documentElement.contains(returnFocusTarget)) {
        try {
          returnFocusTarget.focus({ preventScroll: true });
        } catch (error) {
          returnFocusTarget.focus();
          restoreScrollPosition();
        }
      }

      returnFocusTarget = null;
      savedScrollY = null;
    });
  }

  document.addEventListener('click', function (event) {
    var headerCartToggle = event.target.closest('.site-header__cart.ajax-cart__toggle');
    if (!headerCartToggle || !addToCartButton) return;

    // The base theme resets PDP buttons on every cart-toggle click. Restore the
    // successful variant after that handler runs so a manual drawer open does
    // not expose the stale hidden "Adding..." label.
    window.setTimeout(restoreCheckoutState, 0);
  });

  document.addEventListener('gh_product_variant_changed', function () {
    addToCartButton = null;
  });

  document.addEventListener('percept:cart-add-success', function () {
    var notifications = document.querySelectorAll('[data-cart-notification]');

    addToCartButton = document.querySelector(
      '[data-cart-submit].product__add-to-cart-button-clicked'
    );
    returnFocusTarget = document.activeElement;
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    for (var index = 0; index < notifications.length; index += 1) {
      notifications[index].textContent = '';
      notifications[index].classList.remove('product__notification--success');
      notifications[index].removeAttribute('role');
    }

    var toggle = visibleCartToggle();
    if (!toggle) return;

    window.requestAnimationFrame(function () {
      toggle.click();
      restoreCheckoutState();
    });
  });

  document.addEventListener('click', changeItemQuantity);

  window.addEventListener('pageshow', resetCheckoutLoader);

  preloadCurrentProductImages();
  updateBatchUtility();
  window.setInterval(updateBatchUtility, 60000);
})();
